// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea5390e8","239":"f437417a","453":"31bb2fc5","455":"2debb699"}[chunkId] + ".chunk.js";
};